import * as React from 'react';
import { cn } from '@/lib/utils';
import { Link } from 'react-router-dom';
// import logo from './img/logo.svg';
import error from './img/error.svg';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

const Error404Wrapper = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-error-404-wrapper',
      // styles
      'flex h-screen w-screen items-start overflow-y-auto bg-gradient-to-b from-[#F5FBFC] to-[#ECECF9] p-12 md:items-center',
      className
    )}
    {...props}
  />
));
Error404Wrapper.displayName = 'Error404Wrapper';

const Error404Content = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'c-error-404-content',
      // styles
      'mx-auto w-full max-w-[1080px]',
      className
    )}
    {...props}
  />
));
Error404Content.displayName = 'Error404Content';

const Error404Logo = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-error-404-logo',
      // styles
      'mb-8 block w-24',
      className
    )}
    {...props}
  />
));
Error404Logo.displayName = 'Error404Logo';

const Error404Img = React.forwardRef(({ className, ...props }, ref) => (
  <img
    ref={ref}
    className={cn(
      'c-error-404-img',
      // styles
      'mb-7 block w-80',
      className
    )}
    {...props}
  />
));
Error404Img.displayName = 'Error404Img';

const Error404Title = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      'c-error-404-title',
      // styles
      'text-3xl font-bold text-neutral-dark',
      className
    )}
    {...props}
  />
));
Error404Title.displayName = 'Error404Title';

const Error404Description = React.forwardRef(({ className, ...props }, ref) => (
  <h1
    ref={ref}
    className={cn(
      'c-error-404-description',
      // styles
      'mb-9 text-xl font-light text-primary-dark',
      className
    )}
    {...props}
  />
));
Error404Description.displayName = 'Error404Description';

export function Error404() {
  const { t, i18n } = useTranslation();
  React.useEffect(() => {
    i18n.changeLanguage(process.env.REACT_APP_LOCALE);
  }, []);

  return (
    <Error404Wrapper>
      <Error404Content>
        {/* <Error404Logo
          className="error-404__logo"
          src={logo}
          alt="logotipo Estudologia"
        /> */}
        <Error404Img
          src={error}
          alt="imagem de erro"
        />

        <Error404Title>{t('notFoundPage.titleOhNo')}</Error404Title>
        <Error404Description>{t('notFoundPage.Description404')}</Error404Description>

        <Button
          variant="outline"
          asChild
        >
          <Link to="/">{t('notFoundPage.buttonBackToPlatform')}</Link>
        </Button>
      </Error404Content>
    </Error404Wrapper>
  );
}
